import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { dashboardPageDef } from '@/components/scm/scm-page-defs';

export default function ScmDashboard() {
  return <ScmPageRenderer pageDef={dashboardPageDef} />;
}
